import {
  FormControl,
  Box,
  Button,
  FormHelperText,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Stack,
  Grid,
} from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { SubmitHandler, useForm } from "react-hook-form";
import { OrderInfoForm } from "./types";
import { ChangeEventHandler, useCallback, useEffect, useState } from "react";
import {
  ResourceOperation,
  useApplicationStore,
} from "../../context/ApplicationStoreContext";

type TakeoutOrderForm = {
  orderId: string;
}
const formSchema = yup.object({
  orderId: yup.string().required("必須です。"),
});

const TakeoutOrderInfo = () => {
  const [flag, setFlag] = useState<boolean>(false);
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm<TakeoutOrderForm>({
    resolver: yupResolver(formSchema),
    defaultValues: {
      orderId: "",
    },
  });
  return (
    <Stack spacing={2}>
      <Box>
        <FormControl sx={{ mt: 1 }}>
          <InputLabel htmlFor="outlined-total">テイクアウトオーダーID</InputLabel>
          <OutlinedInput
            id="outlined-takeout-order-id"
            label="TakeoutOrderId"
            fullWidth
            required
            {...register("orderId")}
            error={"orderId" in errors}
          />

          <FormHelperText className="MuiFormHelperText-root Mui-error">
            {
            /*errors.orderId?.message*/
              flag ? "テイクアウトオーダーが見つかりませんでした。":null
            }
          </FormHelperText>
        </FormControl>
      </Box>
      <Box sx={{ mb: 2 }}>
        <div>
          <Button
            variant="contained"
            onClick={()=>setFlag(true)}
            sx={{ mt: 1, mr: 1 }}
          >
            次へ
          </Button>
        </div>
      </Box>
    </Stack>
  );
};
export default TakeoutOrderInfo;
